<template>
  <div>
    <div class="row">
      <el-dialog
        ref="mapDialog"
        :title="$t('climate.weather_forecast')"
        top="15px"
        width="65%"
        :visible.sync="modals.forecast"
        :close="handleCloseForecast"
        :close-on-click-modal="false"
      >
        <div class="row tac" style="padding: 15px">
          <div class="col-sm-6 col-md-2">
            <div
              class="text-center"
              v-if="currently.currently && Object.keys(currently).length > 0"
            >
              <img
                alt=""
                style="width: 75px"
                v-bind:src="`/static/img/iconos/${currently.currently.icon}.svg`"
              />
              <br />
              <p style="font-family: 'Open Sans', sans-serif">
                {{ currently.currently.summary }}
              </p>
            </div>
            <div class="text-center">
              <p
                class="text-muted"
                style="
                  font-size: 20px;
                  font-family: 'Open Sans', sans-serif;
                  font-weight: bold;
                "
              >
                {{ currentTime }}
              </p>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-10"
            v-if="currently.currently && Object.keys(currently).length > 0"
          >
            <div class="row">
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/temperatura.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.temperature, 1)
                  }}&deg;C</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.temperature') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/humedad.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.humidity * 100, 2)
                  }}%</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.humidity') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/rain.svg" />
                <span style="margin-left: 10px"
                  >{{
                    roundNumber(currently.currently.precipIntensity, 2)
                  }}
                  mm/h</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.precipitation') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/lluvia.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.precipProbability * 100, 2)
                  }}%</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.rain_probability') }}</strong></span
                >
              </div>
            </div>
            <hr />
            <br />
            <div class="row other-climate">
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/viento.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.wind') }}:</strong> <br />{{
                    roundNumber(currently.currently.windSpeed * 3.6, 2)
                  }}
                  Km/h
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/barometro.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.pressure') }}:</strong><br />
                  {{ currently.currently.pressure }} mb
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/rocio.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.dew_point') }}:</strong><br />
                  {{ currently.currently.dewPoint }}&deg;C
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/cloudy.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.cloud') }}:</strong><br />
                  {{ roundNumber(currently.currently.cloudCover * 100, 2) }}%
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/niebla.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.visibility') }}:</strong><br />
                  {{ roundNumber(currently.currently.visibility, 2) }} Km
                </p>
              </div>
              <div class="col-2 text-center">
                <img alt="" src="/static/img/iconos/ozono.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.ozone') }}:</strong><br />
                  {{ currently.currently.ozone }} U.D.
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_assigned_space') }}
            </h5>
          </div>
        </div>
        <br />
        <br />
        <div
          class="row"
          style="padding: 10px"
          v-if="
            Object.keys(chartOptions).length > 0 &&
            Object.values(chartOptions.xAxis.categories).length
          "
        >
          <div class="col-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_assigned_graph') }}
          </h5>
        </div>
      </el-dialog>
      <div class="col-12">
        <div class="row">
          <div class="col-12 map-climate">
            <div
              v-if="renderComponent"
              id="home-map"
              ref="map"
              class="map"
              :style="`height: ${height}px !important;`"
            ></div>
            <div
              id="toolbarDiv"
              class="esri-component esri-widget"
              v-if="renderComponent"
            >
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinCharts from 'src/util/mixinCharts';
import mixinLocation from 'src/util/mixinLocation';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import i18n from 'src/i18n';

export default {
  components: {
    highcharts: Chart,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      center: {
        lat: 37.774546,
        lng: -122.433523,
      },
      stations: [],
      mapData: {},
      map: null,
      flag: null,
      currentlyFullWeek: null,
      currentlySerieBar: null,
      renderComponent: true,
      modals: {
        forecast: false,
      },
      chartOptions: {},
      currently: [],
      currentTime: moment().format('hh:mm:ss'),
      flag: null,
    };
  },
  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    mixinMasters,
    MixinCharts,
    MixinNumbers,
    MixinMenu,
    mixinLocation,
  ],

  watch: {
    '$i18n.locale': 'getChartLabels',
  },

  methods: {
    getChartLabels() {
      if (this.flag) {
        this.chartOptions = this.spline(
          i18n.t('climate.weather_forecast'),
          i18n.t('common_words.zone') + ' ' + this.flag,
          this.currentlyFullWeek,
          this.currentlySerieBar
        );
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleCloseForecast() {
      this.modals.forecast = false;
    },
    showForecast() {
      this.showHideLoading(true);
      this.currently = [];
      this.currentTime = null;
      Axios.getMasters(
        `weatherkitappleapi/getDataApi/${this.map.popup.selectedFeature.attributes.Identificador}`
      ).then((response) => {
        this.modals.forecast = true;
        this.currently = response.data.data;
        (this.flag = this.map.popup.selectedFeature.attributes.Estacion),
          (this.currentlyFullWeek = this.currently.fullWeek),
          (this.currentlySerieBar = this.currently.serie_bar);

        try {
          this.getChartLabels();
        } catch (error) {
          console.log('error: ', error);
        }
        this.currentTime = moment().format('hh:mm:ss');
        this.showHideLoading();
      });
    },

    async loadMap() {
      await this.getPosition();
      this.renderComponent = false;
      this.showHideLoading(true);
      this.$nextTick(async () => {
        this.renderComponent = true;
        await this.loadPointMap(
          null,
          { ...this.stations, mapHeight: this.height },
          7,
          {
            lat: this.center.lat,
            lng: this.center.lng,
          }
        );
        this.showHideLoading();
        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 19%;right: 30px;';
        }, 10);

        setTimeout(() => {
          try {
            const buttonFullScreen =
              document.getElementsByClassName('esri-fullscreen')[0];

            buttonFullScreen.addEventListener('click', function () {
              sessionStorage.setItem('esri-fullscreen', 'true');
            });
          } catch (error) {}
        }, 1000);
      });
    },
  },
  created() {
    this.showHideLoading(true);
    Axios.getMasters('devices/stations/indexfromgis')
      .then((response) => {
        this.stations = response.data.data;
        setTimeout(() => {
          this.loadMap();
        }, 100);
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
      });
  },
};
</script>

<style scoped>
.map-climate {
  overflow: hidden;
  position: relative;
}
.map {
  overflow: hidden;
  position: relative;
}
</style>
